import { SlugNameService } from './../../Services/slug-name.service';
import { Router } from "@angular/router";
import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    OnChanges,
} from "@angular/core";
import { EmbryoService } from "src/app/Services/Embryo.service";

@Component({
    selector: "embryo-ProductCard",
    templateUrl: "./ProductCard.component.html",
    styleUrls: ["./ProductCard.component.scss"],
})
export class ProductCardComponent implements OnInit, OnChanges {
    @Input() product: any;
    @Input() index: any;
    @Input() currency: string = "";
    @Input() type: string = "";
    @Output() addToCart: EventEmitter<any> = new EventEmitter();
    @Output() addToWishlist: EventEmitter<any> = new EventEmitter();
    cartProducts: any;
    lang: any;

    constructor(private router: Router, private embryoService: EmbryoService,private slugNameService:SlugNameService,) {
        this.embryoService.emitLang.subscribe((lang: any) => {
            this.lang = lang;
        });
    }

    ngOnInit() {
        this.embryoService.productCartSub.subscribe(
            (res) => (this.cartProducts = res)
        );
    }

    ngOnChanges() {
        if (this.product) {
            this.product.slug_name = this.getProductName(this.product);
        }
    }

    public addToCartProduct(value: any) {
        this.addToCart.emit(value);
    }

    public productAddToWishlist(value: any, parentClass: any) {
        if (
            !document
                .getElementById(parentClass)
                ?.classList.contains("wishlist-active")
        ) {
            let element = document
                .getElementById(parentClass)
                ?.classList.add(" wishlist-active");
        }
        this.addToWishlist.emit(value);
    }

    public checkCartAlready(singleProduct: any) {
        if (
            !this.cartProducts.some((item: any) => item.id == singleProduct.id)
        ) {
            return true;
        }
    }
    getProductName(product: any) {
        // const nameRouting = product.name_en
        //     .replace(/[^\w\s]/gi, "-")
        //     .replace(/ /g, "-");
        // const parentId = product.parent_id || product.id;
        // return nameRouting + "/" + parentId;
				return this.slugNameService.getProductName(product);
    }
}
